import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../../actions/overtredelseskoderMiljogebyrActions";
import { getGridTableRowData } from "../../../../selectors/miljogebyrSelector";
import DetaljKommentarer from "../../Detalj/DetaljKommentarer";
import GridTable from "../../GridTable";

export default function MiljogebyrGridOgKommentarContainer() {
  const gridTableRowData = useSelector(getGridTableRowData);
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOvertredelseskoderMiljogebyrAction());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section>
      <GridTable name="detaljMiljogebyr" rows={gridTableRowData} />
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <DetaljKommentarer
          internkommentarFraBybetjent={miljogebyr.internkommentar}
          kommentarTilMottager={miljogebyr.kommentar}
        />
      </div>
    </section>
  );
}
